import{urlBuilder as a}from"../utils.js";const i=i=>{const{domain:r,trailingSlash:n}=i;return[{name:"Home",href:a({domain:r,path:"/",trailingSlash:n}),ariaLabel:"Link para a página inicial",color:"primary"}]};export{i as default};
